import goods from '@/views/webpc/CreditMall/GoodsApp/goods'

// 定义路由路径数列表
export default [{
  path: '/goods',
  icon: 'el-icon-s-data',
  name: '商品列表',
  component: goods
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CreditMall/GoodsApp/routers/index.js